import React, { PureComponent } from 'react';
import { DataStoreService } from 'utils';
import styled from '@emotion/styled'
import {sortCaseServices} from '../../../utils/helpers';
import { containers, fontSize, lineHeight, responsiveFontSize } from 'style';
import TeaserImageComponent from './image.component';

class TagsComponent extends PureComponent {
  constructor(props) {
    super(props);

    
    this.state = {
      services: DataStoreService.getServices(),
    };
  }

  render() {

    const sortedServices = sortCaseServices(this.state.services, this.props.tags);

    return <TagText>{sortedServices && sortedServices.map(service => <span key={service}>{service}</span>)}</TagText>;
  }
}

export const TagText = styled.div`
    z-index: 1;
    margin-top: 1.5rem;

    span{
      margin-right: 1rem;
      color: #909090;
      display: inline-block;
    }

    font-size: 13px;
    line-height: 2;

    // transition: all;
    // transition-delay: 0s;
    // transition-duration: 0.5s;
    //   opacity: 0;
    //   transform: translateY(10px)  translateX(${props => props.translateX / containers.innerPX * 100 || 0}vw);
    //   will-change: transform opacity;

`;

export default TagsComponent;
